var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": _vm.$props.customsClass
    }
  }, [_c('CustomText', {
    attrs: {
      "elementType": "h2",
      "customClass": "text-center new-file-upload-header ugcentrypoint-file-uploading-heading",
      "text": _vm.modalTitle
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "content"
    }
  }, [_c('base-spinner', {
    attrs: {
      "size": _vm.spinnerSize,
      "position": "static"
    }
  }), _vm.topSubtitle ? _c('CustomText', {
    attrs: {
      "elementType": "h5",
      "customClass": "text-center new-file-upload-subheader ugcentrypoint-file-uploading-description header--no-text-transform",
      "text": _vm.topSubtitle
    }
  }) : _vm._e(), _vm.bottomSubtitle ? _c('CustomText', {
    attrs: {
      "elementType": "h5",
      "customClass": "text-center new-file-upload-subheader ugcentrypoint-file-uploading-description header--no-text-transform",
      "text": _vm.bottomSubtitle
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }